var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { staticClass: "mb-3 header" },
            [
              _c("b-col", [_c("h5", [_vm._v("Brands")])]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "secondary" },
                      on: { click: _vm.openAddModal }
                    },
                    [_vm._v("\n          + Add\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "content-placeholders",
                _vm._l(6, function(n) {
                  return _c("content-placeholders-img", {
                    key: n,
                    style: { height: "60px", marginBottom: "10px" }
                  })
                })
              )
            : _c(
                "b-row",
                { staticClass: "labelBody" },
                _vm._l(_vm.brands, function(brand) {
                  return _c(
                    "div",
                    { key: brand.id, staticClass: "currFields" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between"
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(brand.name) + "\n          "
                          ),
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  _vm.openEditModal(brand)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-pencil" })]
                          )
                        ]
                      )
                    ]
                  )
                })
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "brandModal",
          attrs: { title: _vm.modalTitle, "hide-footer": "" }
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Brand Name" } },
            [
              _c("b-form-input", {
                on: { input: _vm.checkDuplicate },
                model: {
                  value: _vm.brandName,
                  callback: function($$v) {
                    _vm.brandName = $$v
                  },
                  expression: "brandName"
                }
              }),
              _vm._v(" "),
              _vm.duplicateError
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v("\n        Brand already exists\n      ")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.duplicateError || !_vm.brandName
                  },
                  on: { click: _vm.saveBrand }
                },
                [_vm._v("\n        Save\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.brandModal.hide()
                    }
                  }
                },
                [_vm._v("\n        Cancel\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cf51358", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf51358","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/brands.vue
// module id = 1414
// module chunks = 2